import type { WalletSchema } from '../../_project_types/wallet.types'

const MINIMUM_FUTURE_REVENUE_CENTS = 10 * 100
const TOTAL_MINIMUM_INVESTMENTS_CENTS = 50 * 100

function hasAvailableFutureDispoForBooster(
  availableFutureRevenueFixed: number,
  investorWallet?: WalletSchema
) {
  if (availableFutureRevenueFixed < MINIMUM_FUTURE_REVENUE_CENTS) return false

  if (investorWallet?.funds == null) return false

  const currentDispoCents = investorWallet.funds.available

  const futureDispoCents = availableFutureRevenueFixed + currentDispoCents

  // TODO: predrezervacie - preverit, ci toto spravne funguje, lebo tomu nerozumiem
  if (futureDispoCents < TOTAL_MINIMUM_INVESTMENTS_CENTS) return false

  return true
}

export { hasAvailableFutureDispoForBooster }
